import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Hub from '@mui/icons-material/Hub';
import PendingOutlined from '@mui/icons-material/PendingOutlined';
import ShareOutlined from '@mui/icons-material/ShareOutlined';

const NOTES = [
  {
    Icon: Hub,
    color: 'primary.main',
    title: 'Fulfillment contexts are the hub',
    body: 'Everything needed to ship an order is configured on or referenced by a fulfillment context. Tags add custom metadata for filtering.',
  },
  {
    Icon: ShareOutlined,
    color: 'info.main',
    title: 'Origins and carrier accounts are shared',
    body: 'Neither is owned by a tenant. Contexts reference origins directly and carrier accounts through contracts.',
  },
  {
    Icon: PendingOutlined,
    color: 'warning.main',
    title: 'Lanes not yet mapped',
    body: 'Shipping lanes (routes and service levels) aren’t in this diagram while their structure is still being investigated.',
  },
] as const;

/** Static explanatory cards below the map. */
const ArchitectureNotes: React.FC = () => (
  <Box component="section" aria-label="Notes" sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(260px, 100%), 1fr))', gap: 2 }}>
    {NOTES.map(({ Icon, color, title, body }) => (
      <Paper key={title} variant="outlined" sx={{ display: 'flex', gap: 1.5, px: 2.25, py: 2, borderRadius: 4 }}>
        <Icon sx={{ fontSize: 22, color }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{title}</Typography>
          <Typography sx={{ fontSize: 13, color: 'text.secondary', lineHeight: 1.5 }}>{body}</Typography>
        </Box>
      </Paper>
    ))}
  </Box>
);

export default ArchitectureNotes;
